<template>
  <div class="issuer">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <!-- <v-breadcrumbs :items="['Acquirer']"></v-breadcrumbs>  -->
          <v-breadcrumbs :items="['Issuer']"></v-breadcrumbs>
          <!-- <v-breadcrumbs v-t="'Issuer'"></v-breadcrumbs>  -->
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_CARD')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            New Issuer
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          label="Search"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchIssuer"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="issuer"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >

       <!-- FOR EXPANSION -->
       <template v-slot:expanded-row="{ columns, item }">
                      <!-- <tr>
                        <td :colspan="columns.length">               
                          More info about {{ item.value.deviceId }}
                        </td>
                      </tr> -->
                      <tr>
                        <td>{{ $t("acquirer") }}</td>
                        <td :colspan="columns.length" style="padding: 10px;">
                          <tr v-for="it in item.raw.acquirers" :key="it.id">
                            <td>{{ it.acquirerName }}</td>
                          </tr>
                          
                        </td>
                    </tr>              
        </template>

        <!-- <template v-slot:item.acquirers="{ item }">
          <td>
            <tr v-for="it in item.raw.acquirers" :key="it.id">
              <td>{{ it.acquirerName }}</td>
            </tr>
          </td>
        </template> -->

        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_MOD_CARD')                  
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_DEL_CARD')||
              this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD ISSUER DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form ref="addIssuer" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">New Issuer </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Name"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="issuer_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-text-field label="Floor Limit" :readonly="loading" clearable v-model="issuer_data.f_floorLimit" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-text-field label="Adjust Percentage" :readonly="loading" clearable v-model="issuer_data.f_adjustPer" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-text-field label="PAN mask" :readonly="loading" clearable v-model="issuer_data.f_panMask" ></v-text-field>                                             
                      </v-col>  -->

                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="issuer_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="issuer_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>

                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addIssuer"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Update Issuer</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Name"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="issuer_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-text-field label="Floor Limit" :readonly="loading" :rules="[required]" clearable v-model="issuer_data.f_floorLimit" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-text-field label="Adjust Percentage" :readonly="loading" clearable v-model="issuer_data.f_adjustPer" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-text-field label="PAN mask" :readonly="loading" clearable v-model="issuer_data.f_panMask" ></v-text-field>                                             
                      </v-col>   -->

                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="issuer_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="issuer_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="dialog_update = false"
              >
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateIssuer"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- DELETE DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">{{ $t('do you want to delete') }} ?</span></div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    {{ $t('Close') }}
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteIssuer"
                  >
                    {{ $t('Delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteIssuer">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DELETE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Issuer",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      issuer: [],
      organization: [],
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      issuer_data: {
        f_name: "",
        f_floorLimit: "",
        f_adjustPer: "",
        f_panMask: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      issuerId: "",
      issuer_response: [],
      search: "",
      headers: [
        /* {
            title: 'Id',            
            align: 'start',
            sortable: false,
            key: 'issuerId',
          }, */
        { title: this.$t("Name"), align: "start", key: "name", width: "200px"},
        { title: "", key: "data-table-expand", width: "100px", },
        //{ title: 'Floor Limit', key: 'floorLimit' },
        // { title: "Acquirers", key: "acquirers", sortable: true },
        { title: "Organization", key: "organization.orgName", sortable: true, align: "center" },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //form
      form: false,
      loading: true,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },

    //for select all acquirers
    likesAll () {  
        //return this.selectedFruits.length === this.fruits.length
        return this.issuer_data.f_acquirerList.length === this.acquirers.length
    },
    likesSome () {
        //return this.selectedFruits.length > 0
        return this.issuer_data.f_acquirerList.length > 0
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    resetData() {
      this.query = "";
      this.fetchData();
    },

      //for select all acquirers
      toggle () {
        if (this.likesAll) {
          this.issuer_data.f_acquirerList = []
        } else {
          //this.aid_data.f_acquirerList = this.acquirers.slice()
          let i = 0;
          this.issuer_data.f_acquirerList = [];
          for (i = 0; i < this.acquirers.length; i++) {
              this.issuer_data.f_acquirerList.push(
                this.acquirers[i].id
              );
          }
        }
    },

    resetInput(){     
        this.issuer_data.f_name = "";
        this.issuer_data.f_floorLimit = "";
        this.issuer_data.f_adjustPer = "";
        this.issuer_data.f_panMask = "";
        this.issuer_data.f_acquirerList = [];
        this.issuer_data.f_orgId = "";
        },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose() {
      this.dialog = true;     
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.issuerId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.issuerId = id;
      this.dialog_delete = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler() {
      axios
        .all([
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params:  {pagesize: 100},
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acquirer_response) => {
            // console.log("data2", acquirer_response);

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler method

    async addIssuer() {
      //this.dialog = false
      //console.log("form data", this.issuer_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "issuers",
          {
            name: this.issuer_data.f_name,
            //floorLimit:this.issuer_data.f_floorLimit,
            //adjustPercentage:this.issuer_data.f_adjustPer,
            //panMaskPattern:this.issuer_data.f_panMask,
            floorLimit: 0,
            adjustPercentage: 0,
            panMaskPattern: "(?<=\\d{6})\\d(?=\\d{4})",
            organization_id: this.orgId,
            acquirersList: this.issuer_data.f_acquirerList,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "New Issuer Added" });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "issuers/" + this.issuerId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params:  {pagesize: 100},
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((issuer_response, acquirer_response) => {
            // console.log("data1", issuer_response.data);
            // console.log("data2", acquirer_response.data);

            //get discount data for selected id and display data in for dialog
            if (issuer_response.status == 200) {
              // console.log("Issuer Data", this.issuer_response);
              this.issuer_data.f_name = issuer_response.data.name;
              this.issuer_data.f_floorLimit = issuer_response.data.floorLimit;
              this.issuer_data.f_adjustPer =
                issuer_response.data.adjustPercentage;
              this.issuer_data.f_panMask = issuer_response.data.panMaskPattern;
              //this.discount_data.f_orgId = discount_response.data.organization.orgId
              //this.discount_data.f_acquirerList = discount_response.data.acquirers  //this appoch does not work here . compare it imlementation in Role.vue

              let i = 0;
              this.issuer_data.f_acquirerList = [];
              for (i = 0; i < issuer_response.data.acquirers.length; i++) {
                this.issuer_data.f_acquirerList.push(
                  issuer_response.data.acquirers[i].id
                );
              }
            }

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }

            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler 2 method

    async updateIssuer() {
      this.dialog_update = false;
      this.checkTokenExpiry();
      try {
        // console.log("update form issuer id", this.issuerId);
        // console.log("update form issuer data", this.issuer_data);
        let result = await axios.put(
          window.baseurl + "issuers/" + this.issuerId,
          {
            name: this.issuer_data.f_name,
            //floorLimit:this.issuer_data.f_floorLimit,
            //adjustPercentage:this.issuer_data.f_adjustPer,
            //panMaskPattern:this.issuer_data.f_panMask,
            floorLimit: 0,
            adjustPercentage: 0,
            panMaskPattern: "(?<=\\d{6})\\d(?=\\d{4})",
            //orgId:this.discount_data.f_orgId,
            organization_id: this.orgId,
            acquirersList: this.issuer_data.f_acquirerList,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form issuer result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "Issuer Details Updated" });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteIssuer() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "issuers/" + this.issuerId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "Issuer Deleted" });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "issuers", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("issuer_object", result);
          this.issuer = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "issuers/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("issuer_object", result);

          this.issuer = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },
    // Search issuer
    async searchIssuer() {
      let result;
      this.checkTokenExpiry();
      this.loading = true;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "issuers/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_issuer_object", result);
          this.issuer = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "issuers/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_issuer_object", result);
          this.issuer = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

     /*RULES VALIDATION */

     validateName(value) {
      const regex = /^[A-Za-z0-9_. ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and ."
      );
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },

   


};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }  */
</style>
